var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55937 0C3.5625 0 0 6 0 6C0 6 3.5625 12 9.55937 12C15.4375 12 19 6 19 6C19 6 15.4375 0 9.55937 0ZM9.5 1.8C11.8156 1.8 13.6562 3.66 13.6562 6C13.6562 8.34 11.8156 10.2 9.5 10.2C7.18437 10.2 5.34375 8.34 5.34375 6C5.34375 3.66 7.18437 1.8 9.5 1.8ZM9.5 3.6C8.19375 3.6 7.125 4.68 7.125 6C7.125 7.32 8.19375 8.4 9.5 8.4C10.8062 8.4 11.875 7.32 11.875 6C11.875 5.64 11.8156 5.34 11.6969 5.04C11.5188 5.28 11.2812 5.4 10.9844 5.4C10.5094 5.4 10.0938 4.98 10.0938 4.5C10.0938 4.2 10.2125 3.96 10.45 3.78C10.1531 3.66 9.85625 3.6 9.5 3.6Z",
    fill: "#0E5DAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.5d155264.svg";
export { ForwardRef as ReactComponent };